/* eslint-disable no-param-reassign, no-useless-escape, no-unused-vars */
import angular from 'angular';
import moment from 'moment';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  records: state.user.users,
  subComponent: state.statsbar.activeComponent,
});

/**
 * @ngdoc function
 * @name myConsultApp.controller:table
 * @description
 * # table
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('authorizedUserDetailTableController', ($http, ENV, $ngRedux, $scope, $rootScope, $timeout) => {
    // init variables
    $scope.authorizedUserDetailEnableTableActionMenu = false;
    $scope.authorizedUserDetailInitialLoad = true;
    $scope.authorizedUserDetailIsPageOptions = false;
    $scope.authorizedUserDetailIsSortOptions = false;
    $scope.authorizedUserDetailIsTableActionMenu = false;
    $scope.authorizedUserDetailPageData = {};
    $scope.authorizedUserDetailRecords = [];
    $scope.authorizedUserDetailShowMoreStatus = {};
    $scope.authorizedUserDetailTableLoading = false;

    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.authorizedUserDetailCheckTableActionsDisplay = () => {
      $scope.authorizedUserDetailEnableTableActionMenu = false;
      angular.forEach($scope.authorizedUserDetailTable.actions, (action) => {
        if (!action.superuser || (action.superuser && $rootScope.isSuperUser)) {
          $scope.authorizedUserDetailEnableTableActionMenu = true;
        }
      });
    };

    $scope.authorizedUserDetailCheckRangeErrors = async (filter_key, choice_key, date_field, submission) => {
      const choice = $scope.authorizedUserDetailTable.filters[filter_key].options.choices[choice_key];

      if (!choice.state) {
        choice.from = '';
        choice.to = '';
      } else {
        if (submission) {
          if (!choice.from || !choice.to || choice.from === '' || choice.to === '') {
            choice.error = true;
            return true;
          }
        }

        if (!choice.from || !choice.to || choice.from === '' || choice.to === '') {
          return true;
        }

        let from;
        let to;

        if (date_field) {
          from = moment(choice.from).valueOf();
          to = moment(choice.to).valueOf();
        } else {
          from = choice.from;
          to = choice.to;
        }

        choice.error = to - from < 0;
        return choice.error;
      }
    };

    $scope.authorized_user_detail_watch_timeframe_range = async (filter_key, choice_key, target) => {
      const choice = $scope.authorizedUserDetailTable.filters[filter_key].options.choices[choice_key];

      if (!choice.state) {
        choice.from = '';
        choice.to = '';
      } else {
        const timeframe = await $scope.format_timeframe_range(choice.from, choice.to);
        choice.from = timeframe[0];
        choice.to = timeframe[1];

        if (choice[target] && choice[target] !== '') {
          await angular.forEach(
            $scope.authorizedUserDetailTable.filters[filter_key].options.choices,
            async (_, key) => {
              $scope.authorizedUserDetailTable.filters[filter_key].options.choices[key].state =
                key === choice_key;
            },
          );
        }
      }
    };

    angular.forEach($scope.authorizedUserDetailTable.filters, async (filter, filter_key) => {
      angular.forEach(filter.options.choices, async (choice, choice_key) => {
        if ('from' in choice) {
          $scope.$watch(
            `table.filters[${filter_key}].options.choices['${choice_key}'].from`,
            async () => {
              if (choice.date_field) {
                await $scope.authorized_user_detail_watch_timeframe_range(filter_key, choice_key, 'from');
              }
              await $scope.authorizedUserDetailCheckRangeErrors(
                filter_key,
                choice_key,
                choice.date_field,
                false,
              );
            },
          );
        }

        if ('to' in choice) {
          $scope.$watch(
            `table.filters[${filter_key}].options.choices['${choice_key}'].to`,
            async () => {
              if (choice.date_field) {
                await $scope.authorized_user_detail_watch_timeframe_range(filter_key, choice_key, 'to');
              }

              await $scope.authorizedUserDetailCheckRangeErrors(
                filter_key,
                choice_key,
                choice.date_field,
                false,
              );
            },
          );
        }
      });
    });

    // Angucomplete Filter

    $scope.authorizedUserDetailFilterAngucomplete = (query, key) => {
      return $scope
        .angucompleteSearch(
          $http,
          ENV,
          $scope.authorizedUserDetailTable.filters[key].options.search_endpoint,
          $scope.authorizedUserDetailTable.filters[key].options.search_endpoint_data_key,
          { search: query, autocomplete: true },
        )
        .then((res) => res);
    };

    $scope.authorizedUserDetailFilterAngucompletePage = (query, key) => {
      return $scope
        .angucompleteSearchByUrl(
          $http,
          query,
          $scope.authorizedUserDetailTable.filters[key].options.search_endpoint_data_key,
        )
        .then((res) => res);
    };

    $scope.authorizedUserDetailSetSelectedAngucomplete = (item, key) => {
      $scope.authorizedUserDetailTable.filters[key].options.selected.push(item);
    };

    $scope.authorizedUserDetailRemoveAngucomplete = (id, key) => {
      $scope.authorizedUserDetailTable.filters[key].options.selected = $scope.authorizedUserDetailTable.filters[
        key
      ].options.selected.filter((item) => item.id !== id);
    };

    $scope.authorizedUserDetailRemoveAllAngucomplete = (key) => {
      $scope.authorizedUserDetailTable.filters[key].options.selected = [];
    };

    $scope.authorized_user_detail_change_timeframe = async (new_timeframe_choice) => {
      await angular.forEach($scope.authorizedUserDetailTable.filters, async (filter, filter_key) => {
        if (filter.options.query_string_parameter === 'timeframe') {
          await angular.forEach(filter.options.choices, async (choice, choice_key) => {
            $scope.authorizedUserDetailTable.filters[filter_key].options.choices[choice_key].state =
              choice.value === new_timeframe_choice;
          });
        }
      });
    };

    // Get Table Data

    $rootScope.getAuthorizedUserDetail = async () => {
      $scope.authorizedUserDetailTableLoading = true;
      const parameters = { ...$scope.authorizedUserDetailTable.options.default_parameters };

      $scope.authorizedUserDetailPageData = {};
      $scope.authorizedUserDetailRecords = [];

      await angular.forEach($scope.authorizedUserDetailTable.filters, async (filter, key) => {
        if (filter.type === 'multiple_choice') {
          parameters[filter.options.query_string_parameter] = Object.values(filter.options.choices)
            .filter((item) => item.state === true)
            .map((item) => item.value)
            .join(',');

          if (
            (!(filter.options.query_string_parameter in parameters) ||
              parameters[filter.options.query_string_parameter] === '') &&
            'no_selected_parameter' in filter.options
          ) {
            parameters[filter.options.query_string_parameter] =
              filter.options.no_selected_parameter;
          }
        }

        if (filter.type === 'multi_level_multiple_choice') {
          const multi_level_selected = [];

          await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
            if (choice.state === true) {
              if ('options' in choice) {
                let options = '';

                await angular.forEach(choice.options, async (level, level_key) => {
                  if (level.state) {
                    options = `${options}:${level.value}`;
                  }
                });

                if (options !== '') {
                  multi_level_selected.push(`${choice.value}${options}`);
                }
              }
            }
          });

          if (multi_level_selected.length) {
            parameters[filter.options.query_string_parameter] = multi_level_selected.join(',');
          }
        }

        if (filter.type === 'single_choice') {
          await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
            if ('error' in $scope.authorizedUserDetailTable.filters[key].options.choices[choice_key]) {
              $scope.authorizedUserDetailTable.filters[key].options.choices[choice_key].error = false;
            }

            if (choice.state === true) {
              if (choice.type === 'standard') {
                parameters[filter.options.query_string_parameter] = choice.value;
              } else if (choice.type === 'amount') {
                if (!choice.amount || choice.amount === '') {
                  $scope.authorizedUserDetailTable.filters[key].options.choices[choice_key].error = true;
                } else {
                  parameters[
                    filter.options.query_string_parameter
                  ] = `${choice.value}:${choice.amount}`;
                }
              } else if (choice.type === 'range') {
                if (choice.date_field) {
                  const formatted_dates = await $scope.format_timeframe_range(
                    choice.from,
                    choice.to,
                  );

                  let date = null;

                  if (formatted_dates[0] && formatted_dates[0] !== '') {
                    date = moment(formatted_dates[0]);
                    $scope.authorizedUserDetailTable.filters[key].options.choices[
                      choice_key
                    ].to = date.isValid() ? date.format('YYYY-MM-DD') : null;
                  }

                  if (formatted_dates[1] && formatted_dates[1] !== '') {
                    date = moment(formatted_dates[1]);
                    $scope.authorizedUserDetailTable.filters[key].options.choices[
                      choice_key
                    ].to = date.isValid() ? date.format('YYYY-MM-DD') : null;
                  }

                  if (
                    $scope.authorizedUserDetailTable.filters[key].options.choices[choice_key].from &&
                    $scope.authorizedUserDetailTable.filters[key].options.choices[choice_key].to
                  ) {
                    const hasErrors = await $scope.authorizedUserDetailCheckRangeErrors(
                      key,
                      choice_key,
                      choice.date_field,
                      true,
                    );

                    if (!hasErrors) {
                      parameters[
                        filter.options.query_string_parameter
                      ] = `range:${choice.from}:${choice.to}`;
                    }
                  } else {
                    $scope.authorizedUserDetailTable.filters[key].options.choices[choice_key].error = true;
                  }
                } else if (choice.to && choice.from) {
                  const hasErrors = await $scope.authorizedUserDetailCheckRangeErrors(
                    key,
                    choice_key,
                    choice.date_field,
                    true,
                  );

                  if (!hasErrors) {
                    parameters[
                      filter.options.query_string_parameter
                    ] = `${choice.value}:${choice.from}:${choice.to}`;
                  }
                } else {
                  $scope.authorizedUserDetailTable.filters[key].options.choices[choice_key].error = true;
                }
              }
            }
          });
        }
        if (filter.type === 'angucomplete' && 'search_endpoint' in filter.options) {
          if (filter.options.selected.length) {
            parameters[filter.options.query_string_parameter] = filter.options.selected
              .map((item) => item.id)
              .join(',');
          }
        }
      });

      let error = false;

      await angular.forEach($scope.authorizedUserDetailTable.filters, async (filter, key) => {
        if (filter.type === 'single_choice') {
          await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
            if (
              'error' in $scope.authorizedUserDetailTable.filters[key].options.choices[choice_key] &&
              $scope.authorizedUserDetailTable.filters[key].options.choices[choice_key].error
            ) {
              error = true;
            }
          });
        }
      });

      if (error) {
        return;
      }

      const sortOptions = [];

      await Object.entries($scope.authorizedUserDetailTable.sort_options).forEach(([key, item]) => {
        if (item.state === true) {
          sortOptions.push(item.value === '1' ? key : `-${key}`);
        }
      });

      parameters.order = sortOptions.join(',');
      parameters.page_size = $scope.authorizedUserDetailTable.options.records_per_page;

      $scope
        .getTableData(
          $http,
          ENV,
          $scope.authorizedUserDetailTable.options.endpoint,
          $scope.authorizedUserDetailTable.options.endpoint_data_key,
          parameters,
        )
        .then((res) => {
          $timeout(async () => {
            if ($scope.authorizedUserDetailTable.options.scale_up) {
              if (
                res.meta.count === 0 &&
                'timeframe' in parameters &&
                parameters.timeframe !== 'all' &&
                $scope.authorizedUserDetailInitialLoad
              ) {
                if (parameters.timeframe === 'day') {
                  await $scope.authorized_user_detail_change_timeframe('week');
                } else if (parameters.timeframe === 'week') {
                  await $scope.authorized_user_detail_change_timeframe('year');
                } else if (parameters.timeframe === 'year') {
                  await $scope.authorized_user_detail_change_timeframe('all');
                }

                return $rootScope.getAuthorizedUserDetail();
              }
            }

            $scope.authorizedUserDetailTableLoading = false;
            $scope.authorizedUserDetailPageData = res;
            $scope.authorizedUserDetailInitialLoad = false;
            $scope.authorizedUserDetailShowMoreStatus = {};
            $scope.authorizedUserDetailScrollToTop();
          });
        });
    };

    $scope.goToAuthorizedUserDetailPage = (url) => {
      $scope.authorizedUserDetailTableLoading = true;
      $scope.authorizedUserDetailPageData = {};
      $scope.authorizedUserDetailRecords = [];

      $scope
        .getTableDataByUrl($http, url, $scope.authorizedUserDetailTable.options.endpoint_data_key)
        .then((res) => {
          $timeout(() => {
            $scope.authorizedUserDetailPageData = res;
            $scope.authorizedUserDetailTableLoading = false;
            $scope.authorizedUserDetailScrollToTop();
          });
        });
    };

    $scope.authorizedUserDetailValidCustomValue = (filter_key, choice_key, key) => {
      const choice = $scope.authorizedUserDetailTable.filters[filter_key].options.choices[choice_key];

      if (key === 'amount') {
        choice.amount = choice.amount.replace(/[^0-9\-]+/g, '');

        if (choice.amount === '' || choice.amount === null) {
          return;
        }
      }

      if (key === 'range') {
        choice.from = choice.from.replace(/[^0-9\-]+/g, '');
        choice.to = choice.to.replace(/[^0-9\-]+/g, '');
      }
    };

    $scope.authorizedUserDetailClearText = async (filter_key, choice_key) => {
      await angular.forEach(
        $scope.authorizedUserDetailTable.filters[filter_key].options.choices,
        async (choice, key) => {
          if (key === choice_key) {
            choice.state = true;
          } else {
            choice.state = false;
            if ('error' in choice) {
              choice.error = false;
            }
            if ('amount' in choice) {
              choice.amount = '';
            }
            if ('from' in choice || 'to' in choice) {
              $scope.authorizedUserDetailCheckRangeErrors(filter_key, key, choice.date_field, false);
            }
          }
        },
      );
    };

    $scope.authorizedUserDetailSwitchSelectAll = (key, value) => {
      Object.values($scope.authorizedUserDetailTable.filters[key].options.choices).forEach((item) => {
        item.state = value;
        if ('options' in item) {
          Object.values(item.options).forEach((option) => {
            option.state = value;
          });
        }
      });
    };

    $scope.authorizedUserDetailShowPageOptions = () => {
      $scope.authorizedUserDetailIsPageOptions = !$scope.authorizedUserDetailIsPageOptions;
    };

    $scope.authorizedUserDetailSelectPageOption = (option) => {
      $scope.authorizedUserDetailTable.options.records_per_page = option;
    };

    $scope.authorizedUserDetailShowSortOptions = () => {
      $scope.authorizedUserDetailIsSortOptions = !$scope.authorizedUserDetailIsSortOptions;
    };

    $scope.authorizedUserDetailSelectSort = async (option_key, value) => {
      await angular.forEach($scope.authorizedUserDetailTable.sort_options, async (option, key) => {
        if (key === option_key) {
          option.value = value;
          option.state = true;
        }
      });
    };

    $scope.authorizedUserDetailSelectSortOptions = () => {
      $scope.authorizedUserDetailIsSortOptions = false;
    };

    $scope.authorizedUserDetailShowSortTitles = () => {
      return Object.values($scope.authorizedUserDetailTable.sort_options)
        .filter((item) => item.state === true)
        .map((item) => item.title)
        .join(', ');
    };

    $scope.authorizedUserDetailGetChoices = async () => {
      await Promise.all(
        $scope.authorizedUserDetailTable.filters.map(async (value, key) => {
          if (
            (value.type === 'multiple_choice' || value.type === 'multi_level_multiple_choice') &&
            'choices_endpoint' in value.options
          ) {
            const choices = await $scope.getTableFilterOptions(
              $http,
              ENV,
              value.options.choices_endpoint,
              value.options.choices_endpoint_data_key,
            );
            if (choices && !!choices.length) {
              await choices.forEach((item) => {
                const state =
                  ('default_choice' in value.options &&
                    item[value.options.name_attribute] === value.options.default_choice) ||
                  !('default_choice' in value.options);

                $scope.authorizedUserDetailTable.filters[key].options.choices[
                  item[value.options.name_attribute]
                ] = {
                  state,
                  value: item.id,
                };

                if ('level' in value.options && value.options.level) {
                  $scope.authorizedUserDetailTable.filters[key].options.choices[
                    item[value.options.name_attribute]
                  ].options = angular.copy(value.options.level);
                }
              });
            }
          }
        }),
      );

      $rootScope.getAuthorizedUserDetail();
    };

    $scope.authorizedUserDetailGetRedemptionDetail = (index, redemption_id) => {
      $scope
        .getTableData($http, ENV, `/2.0/redemptions/${redemption_id}/`, 'redemptions', {})
        .then((res) => {
          $timeout(async () => {
            $scope.authorizedUserDetailPageData[$scope.authorizedUserDetailTable.options.endpoint_data_key][
              index
            ].redemption = res.redemptions;
            $scope.authorizedUserDetailPageData[$scope.authorizedUserDetailTable.options.endpoint_data_key][
              index
            ].redemption.reward = res.redemptions.reward.description;
          });
        });
    };

    $scope.authorizedUserDetailGetTransactionDetail = (index, transaction_id) => {
      $scope
        .getTableData($http, ENV, `/2.0/transactions/${transaction_id}/`, 'transactions', {})
        .then((res) => {
          $timeout(async () => {
            $scope.authorizedUserDetailPageData[$scope.authorizedUserDetailTable.options.endpoint_data_key][
              index
            ].transaction = res.transaction;
          });
        });
    };

    $scope.authorizedUserDetailShowMore = (index) => {
      $scope.authorizedUserDetailShowMoreStatus[index] = !$scope.authorizedUserDetailShowMoreStatus[index];

      const option =
        $scope.authorizedUserDetailPageData[$scope.authorizedUserDetailTable.options.endpoint_data_key][index];

      if ($scope.authorizedUserDetailTable.options.row_style === 'redemption' && !('redemption' in option)) {
        $scope.authorizedUserDetailGetRedemptionDetail(index, option.id);
      } else if (
        $scope.authorizedUserDetailTable.options.row_style === 'activity' &&
        !('redemption' in option) &&
        !('transaction' in option)
      ) {
        if (option.activity_type.includes('Redemption')) {
          $scope.authorizedUserDetailGetRedemptionDetail(index, option.redemption_id);
        } else if (option.activity_type.includes('Transaction')) {
          $scope.authorizedUserDetailGetTransactionDetail(index, option.transaction_id);
        }
      }
    };

    $scope.authorizedUserDetailShowTableActionMenu = () => {
      $scope.authorizedUserDetailIsTableActionMenu = !$scope.authorizedUserDetailIsTableActionMenu;
    };

    $scope.authorizedUserDetailScrollToTop = () => {
      $('authorized-user-detail-table .container').scrollTop(0);
      $('authorized-user-detail-table .filter-panel').scrollTop(0);
    };

    $(document).on('click', (event) => {
      const pageOptionEle = $('authorized-user-detail-table .page-content');
      const sortOptionEle = $('authorized-user-detail-table .sort-content');
      const tableActionsEle = $('authorized-user-detail-table .table-actions-options');

      const $target = $(event.target);

      if (
        pageOptionEle !== event.target &&
        !$target.closest('authorized-user-detail-table .page-content').length &&
        !pageOptionEle.has(event.target).length
      ) {
        $timeout(() => {
          $scope.authorizedUserDetailIsPageOptions = false;
        });
      }
      if (
        sortOptionEle !== event.target &&
        !$target.closest('authorized-user-detail-table .sort-content').length &&
        !sortOptionEle.has(event.target).length &&
        $scope.authorizedUserDetailIsSortOptions
      ) {
        $timeout(() => {
          $scope.authorizedUserDetailIsSortOptions = false;
          $scope.authorizedUserDetailSelectSortOptions();
        });
      }
      if (
        tableActionsEle !== event.target &&
        !$target.closest('authorized-user-detail-table .table-actions-options').length &&
        !tableActionsEle.has(event.target).length &&
        $scope.authorizedUserDetailIsTableActionMenu
      ) {
        $timeout(() => {
          $scope.authorizedUserDetailIsTableActionMenu = false;
        });
      }
    });

    $scope.generateActivityAuthorizedUserDetailLink = (authorizedUserId) => {
      return `${$rootScope.routes['user-activity']}/authorized-user-detail/${authorizedUserId}`;
    };

    $scope.init();

    const authorizedUserDetailComponentVisibleListener = $rootScope.$watch('componentOpened', () => {
      if (!$rootScope.componentOpened) {
        $scope.authorizedUserDetailEnableTableActionMenu = false;
        $scope.authorizedUserDetailInitialLoad = true;
        $scope.authorizedUserDetailIsPageOptions = false;
        $scope.authorizedUserDetailIsSortOptions = false;
        $scope.authorizedUserDetailIsTableActionMenu = false;
        $scope.authorizedUserDetailPageData = {};
        $scope.authorizedUserDetailRecords = [];
        $scope.authorizedUserDetailShowMoreStatus = {};
        $scope.clearAuthorizedUserDetail();
      }
    });

    const authorizedUserIdListener = $rootScope.$watch('adminAuthorizedUser', () => {
      if ($rootScope.adminAuthorizedUser) {
        $scope.setTable();
        $scope.authorizedUserDetailEnableTableActionMenu = false;
        $scope.authorizedUserDetailInitialLoad = true;
        $scope.authorizedUserDetailIsPageOptions = false;
        $scope.authorizedUserDetailIsSortOptions = false;
        $scope.authorizedUserDetailIsTableActionMenu = false;
        $scope.authorizedUserDetailPageData = {};
        $scope.authorizedUserDetailRecords = [];
        $scope.authorizedUserDetailShowMoreStatus = {};
        $scope.authorizedUserDetailCheckTableActionsDisplay();
        $scope.authorizedUserDetailGetChoices();
        $scope.authorizedUserDetailScrollToTop();
      } else {
        $scope.authorizedUserDetailEnableTableActionMenu = false;
        $scope.authorizedUserDetailInitialLoad = true;
        $scope.authorizedUserDetailIsPageOptions = false;
        $scope.authorizedUserDetailIsSortOptions = false;
        $scope.authorizedUserDetailIsTableActionMenu = false;
        $scope.authorizedUserDetailPageData = {};
        $scope.authorizedUserDetailRecords = [];
        $scope.authorizedUserDetailShowMoreStatus = {};
        $scope.clearAuthorizedUserDetail();
      }
    });

    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      authorizedUserIdListener();
      authorizedUserDetailComponentVisibleListener();
    });
  })
  .directive('authorizedUserDetailTable', () => {
    return {
      templateUrl: 'templates/v2/authorized-user-detail-table.html',
    };
  });
